import React from "react";
import PropTypes from "prop-types";
import GTMTracker from "../../utils/tracking/GTMTracker";
import { getPaddedDurationFromMilliSeconds } from "../../utils/TimeFormatter";
import { generateSmallThumbnailUrl } from "../../utils/ImageUtils";
import { applyRelativeTimestamp } from "../../utils/relativeTimestamp";
import { delayNavigateTo, stripDomainFromUrl } from "../../utils/Navigation";

class MoreFromCurrentShow extends React.Component {
    render() {
        const { relatedSeriesAndVideosData } = this.props;

        if (
            !relatedSeriesAndVideosData ||
            relatedSeriesAndVideosData.length === 0
        ) {
            return null;
        }

        return (
            <ul className="more-from-current-show">
                {this._generateShowsHtml()}
            </ul>
        );
    }

    _generateShowsHtml() {
        const { relatedSeriesAndVideosData } = this.props;

        return relatedSeriesAndVideosData.map((show) => {
            const { seriesId, seriesName, videoStories } = show;

            if (!seriesId || !seriesName) {
                return null;
            }

            const seriesPageLinkAddress = `/series/${seriesId}`;

            return (
                <li
                    key={`Show-${seriesId}`}
                    className="more-from-current-show__series"
                >
                    <h2 className="more-from-current-show__show-name">
                        <a
                            className="more-from-current-show__show-name-link"
                            href={seriesPageLinkAddress}
                            onClick={trackHeadline.bind(this, seriesId)}
                            target="_blank"
                        >
                            {`More From ${seriesName}`}
                        </a>
                    </h2>
                    <ul className="more-from-current-show__videos">
                        {this._generateShowVideosHtml(videoStories, seriesId)}
                    </ul>
                    <a
                        className="more-from-current-show__show-page-link"
                        href={seriesPageLinkAddress}
                        onClick={trackAllShows.bind(this, seriesId)}
                        target="_blank"
                    >
                        All episodes and clips
                    </a>
                </li>
            );
        });
    }

    _generateShowVideosHtml(videoStories, seriesId) {
        return videoStories.map((videoStory) => {
            const {
                url,
                thumbnailUrl,
                duration,
                headline,
                publishedAt,
                bmmrId,
            } = videoStory;

            return (
                <li
                    key={`Show-video${bmmrId}`}
                    className="more-from-current-show__video"
                >
                    <a
                        className="more-from-current-show__video-link"
                        href={stripDomainFromUrl(url)}
                        onClick={(event) => {
                            navigateToVideo(seriesId, videoStory, event);
                        }}
                    >
                        <div className="more-from-current-show__video-info">
                            <div className="more-from-current-show__video-thumbnail-wrapper">
                                <img
                                    className="more-from-current-show__video-thumbnail"
                                    loading="lazy"
                                    src={generateSmallThumbnailUrl(
                                        thumbnailUrl,
                                        195,
                                        110
                                    )}
                                    alt=""
                                />
                                <span className="more-from-current-show__video-duration">
                                    {getPaddedDurationFromMilliSeconds(
                                        duration
                                    )}
                                </span>
                            </div>
                            <h3
                                className="more-from-current-show__video-headline"
                                dangerouslySetInnerHTML={{ __html: headline }}
                            />
                        </div>
                        <time
                            className="more-from-current-show__video-published-time"
                            dateTime={publishedAt}
                        >
                            {applyRelativeTimestamp(publishedAt)}
                        </time>
                    </a>
                </li>
            );
        });
    }
}

function trackHeadline(headline) {
    GTMTracker.trackEngagement({
        bvpEventAction: "click",
        bvpEventLabel: `video-btf_algo_${headline}.headline`,
    });
}

function trackAllShows(headline) {
    GTMTracker.trackEngagement({
        bvpEventAction: "click",
        bvpEventLabel: `video-btf_algo_${headline}.link`,
    });
}

function navigateToVideo(seriesId, { duration, headline }, event) {
    GTMTracker.trackEngagement({
        bvpEventAction: "click",
        bvpEventLabel: `video-btf_algo_${seriesId}.video`,
        mediaTitle: headline,
        mediaProgram: seriesId,
        mediaDuration: duration,
    });

    delayNavigateTo(event);
}

MoreFromCurrentShow.defaultProps = {
    relatedSeriesAndVideosData: [],
};

MoreFromCurrentShow.propTypes = {
    relatedSeriesAndVideosData: PropTypes.arrayOf(PropTypes.object),
};

export default MoreFromCurrentShow;
